const React = require('react');
const PropTypes = require('prop-types');
const { Link } = require('react-router-dom');
const { formatText } = require('core/i18n').i18n;


const NoUserBox = () => (
    <div className="user-fund-box__no-user-box">
        <p>
            {formatText('fundsCard-notLoggedMessage')}
        </p>
        <p>
            {formatText('fundsCard-notLoggedIfClient')}
            &nbsp;
            <Link to="/login">{formatText('fundsCard-loginButton')}</Link>
        </p>
        <p>
            {formatText('fundsCard-notLoggedIfNotClient')}
            &nbsp;
            <Link to="/hazte-cliente">{formatText('fundsCard-signupButton')}</Link>
        </p>
    </div>
);


NoUserBox.propTypes = {
    fund: PropTypes.object.isRequired,
};


module.exports = NoUserBox;
